<template>
  <div class="pa-2">
    <h3>Mock time</h3>
    <div>Current time: {{ formattedTime }}</div>
    <div>
      <v-layout>
        <v-select
          v-model="selectedStep"
          :items="[
            { text: '5 minutes', value: '5m' },
            { text: '1 hour', value: '1h' },
            { text: '1 day', value: '1d' },
            { text: this.nextEvent, value: 'next' },
          ]"
        ></v-select>

        <v-btn @click="step(selectedStep)" flat small class="mt-3">
          <v-icon>forward</v-icon>
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      time: null,
      serverInterval: null,
      localInterval: null,
      selectedStep: '5m',
    };
  },
  async created() {
    await this.fetchTime();
  },
  mounted() {
    this.serverInterval = setInterval(() => {
      this.fetchTime();
    }, 60 * 1000);

    this.localInterval = setInterval(() => {
      this.time = moment(this.time)
        .add(1, 'seconds')
        .toDate();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.serverInterval);
    clearInterval(this.localInterval);
  },
  computed: {
    formattedTime() {
      return this.time ? moment(this.time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    dates() {
      const dates = [
        { name: 'Debt generation', time: moment(this.time).set('date', 1) },
        { name: 'Paper invoice generation', time: moment(this.time).set('date', 5) },
        { name: 'Paper invoice sending', time: moment(this.time).set('date', 15) },
        { name: 'Debt processing/BGC', time: moment(this.time).set('date', 26) },
        {
          name: 'Debt generation',
          time: moment(this.time)
            .add(1, 'month')
            .set('date', 1),
        },
      ];

      return dates;
    },
    nextEvent() {
      for (let i = 0; i < this.dates.length; i++) {
        const item = this.dates[i];

        if (item.time.isAfter(this.time)) {
          return item.name;
        }
      }

      return '';
    },
  },
  methods: {
    async fetchTime() {
      try {
        const response = await this.$http.get('/mocks/mock/time');
        this.time = response.data.time;
      } catch (error) {
        // console.error(error);
      }
    },
    async step(time) {
      let timestamp = moment(this.time);

      switch (time) {
        case '5m':
          timestamp = timestamp.add(5, 'minutes');
          break;

        case '1h':
          timestamp = timestamp.add(1, 'hours');
          break;

        case '1d':
          timestamp = timestamp.add(1, 'days');
          break;

        case 'next':
          for (let i = 0; i < this.dates.length; i++) {
            const item = this.dates[i];

            if (item.time.isAfter(this.time)) {
              timestamp = this.dates[i].time;
              break;
            }
          }

          timestamp = timestamp
            .set('hours', 7)
            .set('minutes', 0)
            .set('seconds', 0);

          break;

        default:
          return;
      }

      await this.stepForward(timestamp);
    },
    async stepForward(timestamp) {
      try {
        await this.$http.put('/mocks/mock/time', { time: timestamp });
        await this.fetchTime();
      } catch (error) {
        // console.error(error);
      }
    },
  },
};
</script>
